module.exports = __webpack_public_path__ + "img/1-20.ce2a9042.jpg";